import { DeliveryNs } from "ReactApp/Types/DeliveryNs";
import { DeliveryObjectTypeEnum } from "ReactApp/Types/enum";

export function deliveryRawSetToDeliverySet(
    deliveryRawSet: DeliveryNs.DeliveryRawSetInterface
): DeliveryNs.DeliverySet {
    let deliverySet: DeliveryNs.DeliverySet = new Map();
    for (let key in deliveryRawSet) {
        let tokens = key.split("__");
        deliverySet.set(generateDeliveryObjectKey(
            parseInt(tokens[0]),
            parseInt(tokens[1])
        ), deliveryRawSet[key]);
    }
    return deliverySet;
}

export function generateDeliveryObjectKey(
    deliveryObjectTypeId: number,
    deliveryOjectId: number,
    separator: string = "__",
): string
{
    return `${deliveryObjectTypeId}${separator}${deliveryOjectId}`;
}